import Alpine from "alpinejs";

Alpine.data("filterwrapper", (itemCount, itemsSelector) => ({
    filterSchema: [],
    filterTags: [],
    filterObj: {},
    itemsSelector: "",
    itemsElementList: [],
    itemsTotal: 0,
    itemsVisible: 0,
    initFilter(element) {
        this.filterSchema = JSON.parse(element.getAttribute("data-schema"));
        this.filterTags = JSON.parse(element.getAttribute("data-tags"));
        this.resetFilter();
        this.$watch("filterObj", (value) => {
            this.filterActive = Object.entries(value).some(([key, value]) => this.emptyFilter(key, value));
            this.updateItemsVisible();
        });
    },
    collapsedCount: 3,
    showAllItems: false,
    init() {
        this.showAllItems = itemCount <= this.collapsedCount;

        if (itemsSelector) {
            this.itemsElementList = this.$root.querySelectorAll(itemsSelector);
            if (this.itemsElementList) {
                this.itemsTotal = Array.from(this.itemsElementList).length;
            }
            this.updateItemsVisible();
        }

        if (this.showAllItems === false && document.location.hash === "#show-all") {
            this.toggleShowAll();
        }
    },
    updateItemsVisible() {
        if (!this.itemsElementList) {
            return;
        }

        this.$nextTick(() => {
            this.itemsVisible = Array.from(this.itemsElementList).filter((element) => {
                return element.offsetParent !== null;
            }).length;
        });
    },
    toggleShowAll() {
        this.showAllItems = true;
        document.location.hash = "show-all";
    },
    filterActive: false,
    filterLabel(category) {
        if (this.filterSchema[category] === "single") {
            return this.filterObj[category] === "all"
                ? this.filterTags[category].label
                : this.filterTags[category].tags[this.filterObj[category]];
        } else {
            return this.filterObj[category].length > 0
                ? this.filterTags[category].label + " (" + this.filterObj[category].length + ")"
                : this.filterTags[category].label;
        }
    },
    fullFilterLabel() {
        return Object.entries(this.filterObj)
            .map(([key, value]) => {
                return this.emptyFilter(key, value) ? this.filterLabel(key) : "";
            })
            .filter((entry) => entry !== "")
            .join(", ");
    },
    emptyFilter(key, value) {
        return this.filterSchema[key] === "single" ? value !== "all" : value.length !== 0;
    },
    resetFilter() {
        this.filterObj = Object.fromEntries(
            Object.entries(this.filterSchema).map(([key, value]) => {
                return [key, value === "single" ? "all" : []];
            })
        );
    },
    isVisible(element, index) {
        if (!element._tags) {
            element._tags = JSON.parse(element.getAttribute("data-tags"));
        }
        return this.filterActive
            ? Object.entries(this.filterObj).every(([key, value]) => {
                  return this.filterSchema[key] === "single"
                      ? value === "all" || value === element._tags[key]
                      : value.length === 0 || value.every((tag) => element._tags[key]?.includes(tag));
              })
            : this.showAllItems || this.collapsedCount > index;
    },
}));
